import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CmsArticle, CmsTemplate } from '@fcom/core-api/interfaces';
import { FragmentService } from '@fcom/common';
import { ButtonTheme, ModalButtons } from '@fcom/ui-components';
import { finShare } from '@fcom/rx';

import { Category } from '../../api/models';

@Component({
  selector: 'fin-information-modal',
  templateUrl: 'information-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationModalComponent implements OnInit {
  readonly ModalButtons = ModalButtons;
  readonly ButtonTheme = ButtonTheme;

  @Input()
  category: Category;

  @Input()
  upsell = false;

  showModal = false;

  modalArticle$: Observable<CmsTemplate>;

  translationPrefix: string;

  @Output()
  upsellClicked: EventEmitter<Category> = new EventEmitter<Category>();

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.translationPrefix = `ancillaries.${this.category}.moreInfo`;
    this.modalArticle$ = this.fragmentService
      .getFragment<CmsArticle>(`${this.translationPrefix}.modal.article.url`)
      .pipe(
        map((article) => {
          return {
            header: [],
            main: [article],
            footer: [],
          };
        }),
        finShare()
      );
  }

  emitUpsellClick(): void {
    this.upsellClicked.emit(this.category);
    this.showModal = false;
  }
}
